import React, { useEffect, useState } from 'react';
// @ts-ignore:next-line
import { Layout, Headline } from '@folio/stripes/components';
import { t, parseErrorPayload } from '../../services';
import css from './ErrorComponents.module.css';
export var ErrorComponent = function (_a) {
    var error = _a.error;
    var _b = useState(''), errorKey = _b[0], setErrorKey = _b[1];
    useEffect(function () {
        parseErrorPayload(error)
            .then(function (_a) {
            var code = _a.code;
            setErrorKey(code);
        });
    }, [error]);
    if (!errorKey) {
        return null;
    }
    return (React.createElement("section", { className: css.errorTitleWrapper },
        React.createElement(Layout, { className: "display-flex flex-align-items-center centerContent" },
            React.createElement(Headline, { size: "x-large", tag: "h1", faded: true }, t("error-component.".concat(errorKey))))));
};
